import $ from 'jquery';
import BaseSettings from './base-settings';
import {registerSettings} from "./register";

class GooglePaySettings extends BaseSettings {
    constructor(props) {
        super(props);
        this.initialize();
    }

    initialize() {

    }
}

registerSettings('ppcp_googlepay', GooglePaySettings);